import { Box, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { BaseTile } from "./BaseTile"

export default function ComingSoonTile(): JSX.Element {
  const theme = useTheme()

  return (
    <BaseTile sx={{ display: "flex", alignItems: "center" }}>
      <Stack
        spacing={theme.spacing(theme.tokens.spacing.xs)}
        justifyContent="center"
        alignItems="center"
        sx={{ inlineSize: "100%" }}
      >
        <Box
          component="img"
          src={`/images/Savings@2x.png`}
          srcSet={`/images/Savings@2x.png`}
          alt=""
          width={42}
          height={42}
        ></Box>
        <Typography variant="h4">
          <FormattedMessage defaultMessage="Coming soon!" />
        </Typography>
      </Stack>
    </BaseTile>
  )
}
